const getSecondTypeColor = (pokemonType) => {
    // Si pokemonType est une chaîne JSON, on la parse
    let types = pokemonType;
    try {
        if (typeof pokemonType === 'string') {
            types = JSON.parse(pokemonType);
        }
        
        const firstType = Array.isArray(types) ? types[0] : types;
        const secondType = Array.isArray(types) ? types[1] : null;

        // Si pas de second type, on retourne la couleur basée sur le premier type
        if (!secondType) {
            switch (firstType) {
                case 'Grass':
                    return 'rgb(75, 255, 195)';  // Vert
                case 'Water':
                    return 'rgb(75, 150, 255)';  // Bleu
                case 'Psychic':
                    return 'rgb(210, 75, 255)';   // Violet
                case 'Fire':
                    return 'rgb(255, 61, 17)';   // Orange rouge
                case 'Bug':
                    return 'rgb(210, 255, 106)';   // Vert jaune
                case 'Normal':
                    return 'rgb(255, 255, 255)';   // Blanc
                case 'Ground':
                    return 'rgb(135, 81, 43)';   // Marron
                case 'Flying':
                    return 'rgb(255, 255, 255)';   // Blanc
                case 'Poison':
                    return 'rgb(97, 60, 113)';   // Violet foncé
                case 'Electric':
                    return 'rgb(255, 215, 0)';   // Jaune
                case 'Fairy':
                    return 'rgb(255, 173, 228)';   // Rose
                case 'Fighting':
                    return 'rgb(200, 131, 91)';   // Marron clair
                case 'Rock':
                    return 'rgb(135, 81, 43)';   // Marron
                case 'Ice':
                    return 'rgb(129, 240, 255)';   // Bleu clair
                case 'Ghost':
                    return 'rgb(84, 46, 97)';   // Violet
                case 'Dragon':
                    return 'rgb(254, 255, 172)';   // Jaune clair
                case 'Steel':
                    return 'rgb(174, 174, 174)';   // Gris
                case 'Dark':
                    return 'rgb(84, 46, 97)';   // Violet
                default:
                    return 'rgb(75, 255, 195)';
            }
        }

        // Si on a un second type, on utilise sa couleur
        switch (secondType) {
            case 'Grass':
                return 'rgb(75, 255, 195)';  // Vert
            case 'Water':
                return 'rgb(75, 150, 255)';  // Bleu
            case 'Psychic':
                return 'rgb(210, 75, 255)';   // Violet
            case 'Fire':
                return 'rgb(255, 61, 17)';   // Orange rouge
            case 'Bug':
                return 'rgb(210, 255, 106)';   // Vert jaune
            case 'Normal':
                return 'rgb(255, 255, 255)';   // Blanc
            case 'Ground':
                return 'rgb(135, 81, 43)';   // Marron
            case 'Flying':
                return 'rgb(255, 255, 255)';   // Blanc
            case 'Poison':
                return 'rgb(97, 60, 113)';   // Violet foncé
            case 'Electric':
                return 'rgb(255, 215, 0)';   // Jaune
            case 'Fairy':
                return 'rgb(255, 173, 228)';   // Rose
            case 'Fighting':
                return 'rgb(200, 131, 91)';   // Marron clair
            case 'Rock':
                return 'rgb(135, 81, 43)';   // Marron
            case 'Ice':
                return 'rgb(129, 240, 255)';   // Bleu clair
            case 'Ghost':
                return 'rgb(84, 46, 97)';   // Violet
            case 'Dragon':
                return 'rgb(254, 255, 172)';   // Jaune clair
            case 'Steel':
                return 'rgb(174, 174, 174)';   // Gris
            case 'Dark':
                return 'rgb(84, 46, 97)';   // Violet
            default:
                return 'rgb(75, 255, 195)';
        }
    } catch (error) {
        console.error('Erreur lors du parsing du type:', error);
        return 'rgb(75, 255, 195)';  // Couleur par défaut en cas d'erreur
    }
};

export default getSecondTypeColor;